import moment from "moment";
import { useEffect, useState } from "react";
import { BiShow } from "react-icons/bi";
import { Box, IconButton, useDisclosure } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { createColumnHelper } from "@tanstack/react-table";

import { usePaginationApi } from "../../shared/hooks";
import usePagination from "../../features/admin/usePagination";
import { Header } from "../../shared/components";
import { ReportedUserModal } from "../../features/admin/users/components";
import { Table } from "../../features/admin/components";

function ViewReportedUsersPage() {
  const { getWithPagination } = usePaginationApi();
  const [modalData, setModalData] = useState<any | null>(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
;

  const [pagination, setPagination] = usePagination();
  const columnHelper = createColumnHelper<any>();

  const { isLoading, data,refetch } = useQuery({
    queryKey: ["reported-user-list", pagination],
    queryFn: async () => {
      console.log("/admin/list-reported-users");
      const response: any = await getWithPagination("PROFILE_SERVICE", "/api/profile/admin/list-reported-users", {
        perpage: pagination.perPage,
        page: pagination.currentPage,
        search: pagination.searchTerm,
      });

      if (!response?.status) {
        throw new Error(response?.message);
      }

      return {
        data: response?.data.data,
      };
    },
    keepPreviousData: true
  });
  useEffect(() => {
    if (data) {
      setPagination({
        ...pagination,
        currentPage: data?.data?.current_page?? 1,
        perPage: pagination.perPage ??20,
        total: data?.data?.total_items ?? 0,
        totalPages: data?.data?.total_pages ?? 0,
      })
    }
  }, [data])
  

  const onOpenModal = (rowData: any) => {
    setModalData(rowData);
    onOpen();
  };
  const columns = [
    columnHelper.accessor("SN", {
      header: () => <span>SN</span>,
      size: 50,
      cell: (info: any) => {
        return (
          <span>
            {info.row.index + (pagination?.currentPage - 1) * pagination?.perPage + 1}
          </span>
        );
      },
    }),

    columnHelper.accessor("reportedBY", {
      id: "reportedBY",
      header: () => <span>Reported By</span>,
      size: 200,
      cell: (info: any) => {
        return <span>{info?.row?.original?.reporting_user?.full_name}</span>;
      },
    }),
    columnHelper.accessor("reportedTo", {
      id: "reportedTo",
      header: () => <span>Reported To</span>,
      size: 200,
      cell: (info: any) => {
        return <span>{info?.row?.original?.reported_user?.full_name}</span>;
      },
    }),
    columnHelper.accessor("reportedDate", {
      id: "reportedDate",
      header: () => <span>Reported Date</span>,
      size: 200,
      cell: (info: any) => {
        return (
          <span>
            {(info?.row?.original?.createdAt &&
              moment(
                info?.row?.original?.createdAt,
                "YYYY-MM-DDTHH:mmZ"
              ).format("MMMM D, YYYY")) ||
              ""}
          </span>
        );
      },
    }),
    columnHelper.accessor("action", {
      id: "action",
      header: () => <span>{"Action"}</span>,
      size: 200,
      cell: (info: any) => {
        return (
          <span>
            <IconButton
              aria-label="View"
              icon={<BiShow size={"24px"} />}
              onClick={() => onOpenModal(info.row.original)}
            />
          </span>
        );
      },
    }),
  ];

  return (
    <Box>
      <Header
        buttonIcon={null}
        header="List of reported User"
        buttonText={undefined}
        handleOpen={onOpen}
      />
      <Table
        title="List of Reported Users"
        columns={columns}
        rowData={data?.data?.data_list ?? []}
        pagination={pagination}
        setPagination={setPagination}
        loading={isLoading}
      />
      <ReportedUserModal
        isOpen={isOpen}
        onClose={onClose}
        rowData={modalData}
      />
    </Box>
  );
}

export default ViewReportedUsersPage;
